/* eslint-disable no-undef */
import React from "react";
import '../utils/i18n';
import Footer from "../shared/components/Footer/Footer";
import Header from "../shared/components/Header/Header";
import RouterMap from "../shared/components/RouterMap";
import UserLogin from '../shared/components/UserLogin';
import FlashMessages from "../shared/components/FlashMessages/FlashMessages";

const App = () => (
  <div className='app'>
    <UserLogin />
    <Header />
    <FlashMessages />
    <RouterMap />
    <Footer />
  </div>
);

export default App;
